const TEXTS = {
  ALT: {
    MENU: 'Menu indicator',
  },
};

export { TEXTS };
